"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var replace_section_variables_1 = __importDefault(require("../../../utils/replace-section-variables"));
var app_1 = require("../app");
var useContext = React.useContext;
var vitaminImgStyle = { margin: '0 -0.7rem', width: 66 };
exports.default = (function (_a) {
    var _b;
    var closeModal = _a.closeModal, incomingChoice = _a.incomingChoice;
    var _c = useContext(app_1.AppContext), addChoice = _c.addChoice, availableSizes = _c.availableSizes, changeSize = _c.changeSize, choices = _c.choices, mainBundleProduct = _c.mainBundleProduct, size = _c.size;
    var settings = (_b = window.vitaminBundlerApp) === null || _b === void 0 ? void 0 : _b.settings.sizeUpModal;
    var nextSize = availableSizes[size ? availableSizes.indexOf(size) + 1 : 0];
    var savings = (function () {
        var _a;
        if (!mainBundleProduct) {
            return;
        }
        var productsData = (_a = window.vitaminBundlerApp) === null || _a === void 0 ? void 0 : _a.productsData;
        var productData = productsData && productsData[mainBundleProduct.handle];
        var nextSizeVariant = mainBundleProduct.variants.find(function (v) { return v.option1 === nextSize.toString(); });
        if (!nextSizeVariant) {
            return;
        }
        var variantData = productData === null || productData === void 0 ? void 0 : productData.variants[nextSizeVariant.id];
        return variantData === null || variantData === void 0 ? void 0 : variantData.savings;
    })();
    var onSizeUpClick = function () {
        changeSize(nextSize);
        addChoice(incomingChoice);
        closeModal();
    };
    return (React.createElement("div", { className: 'text-center padding-horizontal-4 padding-vertical-8' },
        React.createElement("div", { className: 'font-lighter margin-bottom-2' }, settings === null || settings === void 0 ? void 0 : settings.topText),
        React.createElement("div", { className: 'font-bold h3' }, settings === null || settings === void 0 ? void 0 : settings.title),
        React.createElement("div", { className: 'divider margin-vertical-5 margin-horizontal-auto bg-gold', style: { height: 8, width: 56 } }, "\u00A0"),
        React.createElement("div", { className: 'margin-vertical-8' },
            choices.map(function (_a) {
                var product = _a.product, variant = _a.variant, quantity = _a.quantity;
                return __spreadArray([], __read(Array(quantity).keys()), false).map(function (i) { return React.createElement("img", { key: "img".concat(variant.id).concat(i), src: product.featured_image, alt: variant.title, style: vitaminImgStyle }); });
            }),
            React.createElement("img", { src: incomingChoice.product.featured_image, alt: incomingChoice.product.title, style: vitaminImgStyle }),
            React.createElement("img", { className: 'filter-gray', src: incomingChoice.product.featured_image, alt: incomingChoice.product.title, style: vitaminImgStyle })),
        React.createElement("div", { className: 'margin-vertical-6 text-gray font-lighter padding-horizontal-10' }, (0, replace_section_variables_1.default)((settings === null || settings === void 0 ? void 0 : settings.body) || '', { size: nextSize.toString(), savings: savings || '' })),
        React.createElement("div", { className: 'margin-bottom-6' },
            React.createElement("button", { className: 'button bg-sandy-brown text-white large padding-horizontal-8', onClick: onSizeUpClick }, settings === null || settings === void 0 ? void 0 : settings.yesButtonText)),
        React.createElement("div", null,
            React.createElement("button", { className: 'text-uppercase text-underline h6-7 text-gray', onClick: closeModal }, (0, replace_section_variables_1.default)((settings === null || settings === void 0 ? void 0 : settings.noButtonText) || '', { size: "".concat(size) })))));
});
